import _ from 'lodash';

export default {
  GET_ACCESS_KEY_SUMMARY_WEEK_CHANGE(state, params) {
    state.weekChanges = _.reverse(params);
  },
  GET_ACCESS_KEY_SUMMARY_LAST_SUMMARY(state, params) {
    state.lastSummary = params;
  },
  GET_ACCESS_KEY_SUMMARY_EXCEPT_CNT(state, params) {
    let all = 0;
    params.forEach(obj => {
      all += obj.exceptCnt;
    });
    state.exceptKeys = _.mapValues(_.keyBy(params, 'exceptType'), 'exceptCnt');
    state.exceptKeys.all = all;
  },
  GET_ACCESS_KEY_SUMMARY_D1_CNT(state, params) {
    state.d1Cnt = params;
  },
};



// WEBPACK FOOTER //
// ./src/vuex/accKey/summary/accKeySummaryMutation.js